// extracted by mini-css-extract-plugin
export default {"section":"Section_section__XBF9b","variants-list":"Section_variants-list__Oiyts","variant-wrapper":"Section_variant-wrapper__rlpC2"};